import { Injectable } from '@angular/core';
import { share } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResponseModel } from '../../admin/models/response.model';
import { ContactPageShowModel } from '../model/contact-page.model';
import { ContactFormRequestModel } from '../model/contact-form-request.model';
import { SearchResultModel } from '../model/search-result.model';
import { SearchPageShowModel } from '../model/search-page.model';

const getMenusURL = environment.apiUrl + '/api/MenuContent/ShowMenu';
const getLanguagesURL = environment.apiUrl + '/api/LanguageContent/GetLanguages';
const getMenuLanguagesTitleURL = environment.apiUrl + '/api/LanguageContent/GetMenuLanguagesTitle';
const getMainPageURL = environment.apiUrl + '/api/MainPageContent/Content';
const getPageURL = environment.apiUrl + '/api/PageContent/Content/';
const getContactUsPageURL = environment.apiUrl + '/api/ContactPageContent/Content/';
const getSearchPageURL = environment.apiUrl + '/api/SearchPageContent/Content/';
const getSearchResultURL = environment.apiUrl + '/api/SearchPageContent/GetsearchResult/';
const sendContactFormURL = environment.apiUrl + '/api/ContactPageContent/SendContactForm';

@Injectable()
export class WebSiteService {
    constructor(private http: HttpClient) {
    }

    private getHeader() {
        let language = localStorage.getItem('current-language');
        if (language === undefined || language === null) {
            language = 'tr-TR';
        }
        return {
            headers: {
                'content-type': 'application/json;charset=utf8;',
                'authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                'X-CurrentLanguage': language
            }
        };
    }

    public getLanguages(): Observable<any> {
        var a = this.http.get(getLanguagesURL, this.getHeader()).pipe(share());
        return a;
    }

    public getMenuLanguagesTitle(): Observable<any> {
        return this.http.get(getMenuLanguagesTitleURL, this.getHeader()).pipe(share());
    }

    public getMenus(): Observable<any> {
        return this.http.get(getMenusURL, this.getHeader()).pipe(share());
    }

    public getMainPage(): Observable<any> {
        return this.http.get(getMainPageURL, this.getHeader()).pipe(share());
    }

    public getPage(url): Observable<any> {
        return this.http.get(getPageURL + url, this.getHeader()).pipe(share());
    }

    public getContactUsPage(): Observable<ResponseModel<ContactPageShowModel>> {
        return this.http.get<ResponseModel<ContactPageShowModel>>(getContactUsPageURL, this.getHeader()).pipe(share());
    }

    public getSearchPage(): Observable<ResponseModel<SearchPageShowModel>> {
        return this.http.get<ResponseModel<SearchPageShowModel>>(getSearchPageURL, this.getHeader()).pipe(share());
    }

    public sendContactForm(contactFormModel: ContactFormRequestModel): Observable<any> {
        return this.http.post(sendContactFormURL, contactFormModel, this.getHeader()).pipe(share());
    }

    public getSearchResult(keys: string): Observable<ResponseModel<SearchResultModel[]>> {
        return this.http.get<ResponseModel<SearchResultModel[]>>
        (getSearchResultURL + '?keys=' + (keys && keys.replace(/\s+/g, '+')), this.getHeader()).pipe(share());
    }
}
